/** One slip: the add page while a draft, read-only once previewed. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { Callout } from "@/components/ui/callout";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { IvtPage } from "@/features/processing/components/ivt-page";
import { errMsg, useSlip } from "@/features/processing/hooks";

export const Route = createFileRoute("/_app/packaging/ivt/$id")({
  beforeLoad: () => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const q = useSlip(Number(id));
  const { facilities } = useFacilities();
  if (q.isPending) return <FormPageSkeleton />;
  if (q.isError)
    return (
      <Callout tone="danger" title="Could not load the slip">
        {errMsg(q.error)}
      </Callout>
    );
  const plant = facilities.find((f) => f.id === q.data.facilityId);
  return (
    <IvtPage
      key={`${q.data.id}-${q.data.status}`}
      slip={q.data}
      facilityId={q.data.facilityId}
      plantName={plant ? `${plant.name} (${plant.plantCode})` : null}
    />
  );
}
